
import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import '../Alerts/Alerts.css'
export default class Error extends React.Component {
  constructor (props) {
    super(props)
    console.log('this.props.history.location', this.props.history.location)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      errorMessage: this.props.history.location.state

    }
  }
  render () {
    const language = this.state.currentLanguage
    const populateError = (errors) => {
      return errors.map((err, i) => {
        return <li key={i}>{t[language][err]}</li>
      })
    }
    return (
      <section>
        <div id='ErrorContent'>
          <div className='errorMessages'>
            <h4>{t[language].storeSettingsConfirmError} </h4>
            <ul> {populateError(this.state.errorMessage)}</ul>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Alerts/Error.js